import type { IDeliveryTariff } from '@/types/interfaces/delivery';

export default function (tariffs: IDeliveryTariff[]) {
	return tariffs.reduce((prev, curr) =>
		prev.price < curr.price ? prev : curr
	);
}
